module.exports = __webpack_public_path__ + "img/digimgtwo.240914d7.png";